import { HOME_CARD_LIST } from '../staticData/cardList';
import { isIOS } from 'react-device-detect';
import useNav from './useNav';
import { getAppVersionNum } from '../helper/appUtils';

export const useCardList = (media: string, isMtg?: boolean) => {
  const { navigateByLinkType } = useNav();
  const os = isIOS ? 'IOS' : 'Android';
  const appVersion = getAppVersionNum(media);
  const cardList = HOME_CARD_LIST.filter((item) => {
    let excluded = item.exclude.find((m) => m === media);
    if (excluded) return false;
    if (item.versionFilter) {
      const mediaVersionFilter = item.versionFilter[media];
      if (mediaVersionFilter && mediaVersionFilter[os]) {
        const minVersion = mediaVersionFilter[os];
        return appVersion >= minVersion;
      }
    }
    return true;
  });

  return {
    cardList: cardList.map((item: any) => {
      // 임시로 처리, 애초에 HOME_CARD_LIST를 범용적으로 다 쓰는 게 문제임
      const destination =
        item.primaryText === '이자 계산기'
          ? `/${media}${isMtg ? '/mtg' : ''}/rateCalc`
          : item.link.landingDestinationCollection[media || ''];

      return {
        ...item,
        navigate: () => navigateByLinkType(item.link.landingType, destination),
      };
    }),
  };
};
